import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
    name: 'nfcList',
    initialState: {
        isRequesting: false,
        error: null,

        data: [],
        total: 0,
        searchCriteria: {},

        historyData: [],
        totalHistoryData: 0,
    },
    reducers: {
        get_list: (state, action) => {
            return {
                ...state,
                isRequesting: true,
                error: null,
                searchCriteria: { ...action.payload },
            };
        },
        get_list_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                data: action.payload.items,
                total: action.payload.total,
            };
        },
        get_list_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload.error,
                data: [],
            };
        },
        get_history: (state, action) => {
            return {
                ...state,
                isRequesting: true,
                error: null,
            };
        },
        get_history_suceed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                historyData: action.payload,
            };
        },
        get_history_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload.error,
                historyData: [],
            };
        },
        add_card_registration: (state) => {
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
        update_card_registration: (state) => {
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
        add_card_registration_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: action.payload,
                data: null,
            };
        },
        update_card_registration_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: action.payload,
                data: null,
            };
        },
        add_card_registration_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
            };
        },
        update_card_registration_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
            };
        },
        export_list: (state) => {
            return {
                ...state,
                isRequesting: true,
                error: null,
            };
        },
        export_list_succeed: (state) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
            };
        },
        export_list_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload.error,
            };
        },
    },
});

export const { reducer, actions } = slice;

export default reducer;
